export { default as Text } from './Text'
export { default as TextSpan } from './TextSpan'
export type { TextProps } from './types'
